import { render, staticRenderFns } from "./bounties.vue?vue&type=template&id=1c8fbfbb"
import script from "./bounties.vue?vue&type=script&lang=js"
export * from "./bounties.vue?vue&type=script&lang=js"
import style0 from "./bounties.vue?vue&type=style&index=0&id=1c8fbfbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports